<template>
  <div class="scpm-table-draggable-wrap">
    <div
      class="left-con"
      :style="(width ? 'width:' + width + 'px' : '') + (height ? ';height:' + height + 'px' : '')"
    >
      <c-scroll style="height: 100%; padding: 13px">
        <lego-text-field
          searchable
          v-model="metricModel"
          :placeholder="t('page.eventStatus.inputSearch')"
          @click-icon="metricClickIcon"
          @setMetricItems="setMetricItems"
          :chk="chk"
          :chkMetricItems="chkMetricItems"
        />
        <lego-accordion-item
          ref="accordion"
          v-for="(item1, index1) in getMetricItems"
          :key="index1"
          :index="index1"
          expandable
          class="accordion-item"
          v-show="item1.children.length > 0"
        >
          <template #title>
            <div class="accordion-title">
              <strong v-lego-tooltip:ellipsis="`${item1.name} (${item1.children.length})`">
                {{ item1.name }}
                <em v-if="item1.children">({{ item1.children.length }})</em>
              </strong>
            </div>
          </template>
          <template #expand>
            <draggable
              class="dragArea list-group"
              :list="item1.children"
              :clone="clone"
              :group="{ name: 'metric', pull: 'clone', put: false }"
              @start="start"
              @end="end"
            >
              <div
                v-for="(item2, index2) in item1.children"
                :key="index2"
                class="accordion-sub-item-wrap"
                :class="checked(item2) ? 'checked' : ''"
                @click="checkItem(item2, index1)"
              >
                <div
                  class="accordion-sub-item"
                  :style="checked(item2) ? 'color:#364fc7' : ''"
                  v-lego-tooltip:ellipsis="item2.name"
                >
                  {{ item2.name }}
                </div>
                <div v-if="checked(item2)" class="accordion-check">
                  <lego-icon iconType="df" icon="check" :size="16" :color="'#364fc7'" />
                </div>
              </div>
            </draggable>
          </template>
        </lego-accordion-item>
        <div class="no-data-metric" v-show="this.metrics.length == 0">{{ t('label.noData') }}</div>
      </c-scroll>
    </div>
  </div>
</template>
<script>
import draggable from 'vue-draggable-next';
import i18nMixin from '@/mixins/i18n.mixin.js';

export default {
  mixins: [i18nMixin],
  props: {
    selectedItems: {
      type: Array,
      default: () => {
        return [];
      },
      required: false
    },
    metrics: { type: Array },
    value: { type: Object },
    width: { type: Number, default: 320 },
    height: { type: Number, default: 291 },
    multi: { type: Boolean, default: false },
    cloneFunction: {
      type: Function
    },
    chk: { type: Boolean, default: false },
    chkMetricItems: {
      type: Boolean,
      default: false
    }
  },
  components: { draggable },
  watch: {
    metrics: {
      deep: true,
      handler() {
        this.setItems(this.metrics);
      }
    }
  },
  computed: {
    checked: function () {
      return (item, index) => {
        return this.selectedItems.includes(item.name);
      };
    },
    getMetricItems() {
      let result = [];
      if (this.metricModel) {
        for (let i = 0; i < this.metrics.length; i++) {
          let _item = this.metrics[i];
          let _children = [];
          if (_item.children) {
            for (let c = 0; c < _item.children.length; c++) {
              let child = _item.children[c];
              if (-1 < child.name.toLowerCase().indexOf(this.metricModel.toLowerCase())) {
                _children.push(child);
              }
            }
          }
          result.push({ id: _item.id, name: _item.name, children: _children });
          this.setItems(result);
        }
      } else {
        this.setItems(this.metrics);
      }
      return this.items;
    }
  },
  methods: {
    setItems(items) {
      this.items = items;
    },
    metricClickIcon() {},
    checkItem(item, index) {
      if (!this.multi) {
        this.selectedItems.length = 0;
        if (this.selectedItems.includes(item.name)) {
          let index = this.selectedItems.indexOf(item.name);
          this.selectedItems.splice(index, 1);
        } else {
          this.selectedItems.push(item.name);
          this.$emit('input', this.clone(item));
          this.initAccordion(index);
        }
      } else {
        return;
      }
      this.$forceUpdate();
    },
    clone(item) {
      let cloned = this.$util.deepCopy(item);
      if (this.cloneFunction) cloned = this.cloneFunction(cloned);
      //item.check_object = item.isObjectExist == 'Y';

      return cloned;
    },
    pullFunction() {
      return this.controlOnStart ? 'clone' : true;
    },
    start({ originalEvent }) {
      this.controlOnStart = originalEvent.ctrlKey;
    },
    end(obj) {},
    initAccordion(chk = 0) {
      if (this.chk == true && this.chkMetricItems == true) {
        //this.chkMetricItems = false;
      } else {
        //this.$emit('init');
      }
      let len = this.$refs.accordion.length;
      for (let cnt = 0; cnt < len; cnt++) {
        this.$refs.accordion[cnt].clearExpand();
      }
      this.$refs.accordion[chk].toggleExpand();
    },
    setMetricItems() {
      this.$emit('setMetricItems');
    }
  },
  created() {
    this.items = this.metrics;
  },
  updated() {
    if (this.chk == true) {
      this.initAccordion();
    }
  },
  data() {
    return {
      metricModel: '',
      items: []
    };
  }
};
</script>
<style lang="scss" scoped>
.scpm-table-draggable-wrap {
  display: flex;
  align-items: stretch;
  justify-content: space-between;

  .left-con {
    width: 320px;
    height: 300px;
    padding: 7px;
    background-color: #f8f8f8;

    ::v-deep .lego-text-field {
      margin-bottom: 8px;
      padding-bottom: 8px;
      border-bottom: 1px solid #d2d3d6;
    }

    ::v-deep .lego-text-field__input {
      height: 32px !important;
    }

    ::v-deep .lego-text-field--small .lego-text-field__icon-wrap {
      height: 32px !important;
    }

    .accordion-item {
      background-color: #f7f7f7 !important;
      border: 0px solid #f7f7f7 !important;

      .accordion-title {
        display: flex;
        justify-content: space-between;
        width: 90% !important;

        em {
          font-style: normal;
        }
      }

      .accordion-title strong {
        text-overflow: ellipsis !important;
        white-space: nowrap;
        overflow: hidden !important;
        word-break: break-all;
      }

      .checked.accordion-sub-item-wrap {
        background-color: rgba(54, 79, 199, 0.12) !important;
      }

      .accordion-sub-item-wrap {
        position: relative;
        padding: 8px 40px 8px 10px;
        margin-bottom: 4px;
      }

      .accordion-sub-item-wrap:hover {
        background-color: rgba(54, 79, 199, 0.04);
      }

      .accordion-sub-item {
        display: block;
        font-size: 14px;
        color: #787c84;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        cursor: pointer;
      }

      .accordion-check {
        position: absolute;
        top: 10px;
        right: 9px;
      }
    }

    ::v-deep .accordion-list-item__main {
      padding: 0;
    }

    ::v-deep .accordion-list-item__expand {
      margin: 0 !important;
      padding: 5px !important;
    }
  }

  .right-con {
    width: calc(100% - 370px);
  }
}

.no-data-metric {
  display: flex;
  align-items: center;
  height: 50px;
  justify-content: center;
  color: #bbbdc1;
  font-size: 14px;
  font-weight: 500;
}
</style>
